import React from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";

const style = ({ theme }) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: theme.borderRadius.full,
    backgroundColor: ({ theme: compTheme }) => theme.colors[`${compTheme}2`],
    color: theme.colors.tertiary1,
    fontFamily: theme.fonts.sans,
    fontSize: "16px",
    lineHeight: 1,
    height: 30,
    width: 30
  }
});

/**
 * TODO: Theme support
 */
const Badge = ({ classes, children }) => (
  <div className={classes.root}>{children}</div>
);

Badge.themes = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  TERTIARY: "tertiary",
  QUATERNARY: "quanternary", // Spelling is wrong in theme
  BADGEDONE: "badgeDone"
};

Badge.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.node,
  theme: PropTypes.oneOf(Object.entries(Badge.themes).map(([key, val]) => val))
};

Badge.defaultProps = {
  theme: Badge.themes.SECONDARY
};

export default injectSheet(style)(Badge);
